import { NgModule } from '@angular/core';
import { WgThemerComponent } from './wg-themer.component';
import { MaterialCssVarsModule} from 'angular-material-css-vars';
import { CommonModule } from '@angular/common';
import { LibMaterialModule } from './angular-material/material.module';
import { FormsModule } from '@angular/forms';
import { MenuComponent } from './menu/menu.component';
import { ImageComponent } from './image/image.component';
import { Theme } from './models/colors';



@NgModule({
  declarations: [
    WgThemerComponent,
    MenuComponent,
    ImageComponent,
  ],
  imports: [
    MaterialCssVarsModule,
    CommonModule,
    LibMaterialModule,
    FormsModule
  ],
  providers:[
  ],
  exports: [
    WgThemerComponent,
    ImageComponent
  ]
})
export class WgThemerModule { }
